import { create } from 'zustand'
import { getDdjjMedico } from '@/common/utils/services/usuarios.service'

// PBI 81906: estado de la DDJJ por contrato, compartido por el banner y el menú Mi perfil
// para no consultar dos veces. Se descarta la respuesta si el contrato cambió mientras tanto.
export const useDdjjMedicoStore = create((set, get) => ({
  contrato: null,
  ddjjPendiente: false,
  cargando: false,
  // PBI 81147 (D6): mensaje del toast global de carga exitosa. Vive en el store
  // porque el modal se desmonta al cerrarse y el aviso debe sobrevivirle.
  avisoExito: null,

  cargar: async (contrato) => {
    if (!contrato) {
      set({ contrato: null, ddjjPendiente: false, cargando: false })
      return
    }
    if (get().contrato === contrato) return // ya cargado o en curso

    set({ contrato, ddjjPendiente: false, cargando: true })
    const { code, data } = await getDdjjMedico(Number(contrato))
    if (get().contrato !== contrato) return
    set({ ddjjPendiente: code === 200 && data?.ddjjPendiente === true, cargando: false })
  },

  limpiar: () => set({ contrato: null, ddjjPendiente: false, cargando: false }),

  // PBI 81147: después de una carga exitosa se toma el estado de la respuesta, sin otro request.
  // D8: el store guarda el contrato activo como string y la fila de Mis cuentas lo trae como
  // número, así que la comparación es numérica.
  marcarSubida: (contrato, ddjjPendiente) => {
    if (Number(get().contrato) !== Number(contrato)) return
    set({ ddjjPendiente: ddjjPendiente === true })
  },

  // PBI 81147: fuerza una nueva consulta (409 o envío abortado: el servidor pudo haber guardado igual).
  refrescar: async () => {
    const { contrato } = get()
    if (!contrato) return
    set({ contrato: null })
    await get().cargar(contrato)
  },

  mostrarAviso: (mensaje) => set({ avisoExito: mensaje }),
  cerrarAviso: () => set({ avisoExito: null }),
}))
